import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowCircleRight } from '../shared/icons';
import Button from '../shared/button';
import NewsItem from './news-item';
import './local-news.css';

export default ({ news, heading }) => {
    if(!news) {
      return <></>;
    }

    heading = heading || 'Local News';
    return <div className="row local-news-container">
      <div className="flex-col local-news">
      <h2 className="local-news-heading">{heading}</h2>
      <div className="local-news-card-grid">
        {
          news.slice(0,3).map(newsItem => {
            return <NewsItem data={newsItem} key={newsItem.id}/>
          })
        }
      </div>
      <div className="view-all-news-container">
        <Link to="/news"><Button icon={ArrowCircleRight} type="text">View All News</Button></Link>
      </div>
    </div>
    </div>;
  }
